// extracted by mini-css-extract-plugin
export var deleteIcon = "_m3-5";
export var deleteOption = "_m3-3";
export var divider = "_m3-2";
export var downloadIcon = "_m3-4";
export var drawer = "_m3-0";
export var drawerFooter = "_m3-6";
export var drawerOpen = "_m3-1";
export var highlighted = "_m3-7";
export var lighterHighlight = "_m3-8";